import React, { useState, createRef, useEffect } from "react"

import { AutoComplete } from "antd"
import { fetchAddressAutoComplete } from "../../redux/actionCreators/auth"
import _ from "../../utils/lodashUtils"
import { connect } from "react-redux"
import "./AddressSearchBar.scss"
import { EditFilled, EnterOutlined } from "@ant-design/icons"
import loader from "../../assets/images/loader.svg"
import { SearchBar } from "../../atoms"

const AddressSearchBar = props => {
  // generic component in date wait page, for user and partner address
  const { Option } = AutoComplete
  const { mode, address, setAddress, disabled, icon, placeholder } = props
  const [addressOptions, setAddressOptions] = useState([])
  const searchBarRef = createRef(null)
  const options = addressOptions.map(address => (
    <Option key={address.id} value={address.description}>
      {address.description}
    </Option>
  ))

  const onSelect = value => {
    setAddress(value)
    props.onIconClick(value)
  }

  const handleSearch = async value => {
    setAddress(value)
    if (value.trim()) {
      let addresses = await props.fetchAddressAutoComplete(value)
      setAddressOptions(_.get(addresses, "data", []))
    }
  }
  useEffect(() => {
    if (searchBarRef.current) {
      searchBarRef.current.focus()
    }
  }, [mode])
  return (
    <div className={"search-bar-container" + (disabled ? " disabled" : "")}>
      <SearchBar
        placeholder={placeholder}
        value={address}
        className="search-bar"
        onSearch={handleSearch}
        onSelect={onSelect}
        disabled={disabled}
        ref={searchBarRef}
        autoFocus={true}
      >
        {!_.isEmpty(addressOptions) ? options : null}
      </SearchBar>
      <div
        className={"search-bar-action-icon" + (icon === "edit" ? " edit" : "")}
      >
        {icon ? (
          icon === "saved" ? (
            <EditFilled onClick={() => props.onIconClick()} />
          ) : icon === "edit" ? (
            <EnterOutlined onClick={() => props.onIconClick()} />
          ) : (
            <img
              alt="loading"
              src={loader}
              className="search-input-save"
              onClick={() => {
                props.onIconClick()
              }}
            />
          )
        ) : null}
      </div>
    </div>
  )
}
export default connect(null, {
  fetchAddressAutoComplete,
})(AddressSearchBar)
